import axios from 'axios'
import currentConfig from '../config'

const currentApi = currentConfig?.API_URL

interface buildRouteArg {
    type: string
    route: string
    id?: string | number
    data?: any
}

// Read-only god mode: block obvious write routes while emulating. The error is
// caught by callers and surfaced as a toast.
const WRITE_ROUTE =
    /(^|[-/])(edit|delete|deactivate|activate|create|add|update|save|register|archive|unarchive|upload|provision|assign|remove|change-password|reset-password)/i
const assertNotEmulatingWrite = (route: string) => {
    if ((globalThis as any).osmosisEmulate && WRITE_ROUTE.test(route)) {
        throw new Error(
            'Read-only while emulating — exit god mode to make changes.'
        )
    }
}

const buildRoute = async ({ type, route, data }: buildRouteArg) => {
    let apiRoute: any = ''

    if (type === 'get') {
        apiRoute = await axios.get(`${currentApi}/${route}`)
    }
    if (type === 'post') {
        if (route === 'authenticate') {
            apiRoute = await axios.post(`${currentApi}/${route}`, data)
            globalThis.username = apiRoute?.data.username
        } else if (route === 'user-deactivation-request') {
            apiRoute = await axios.post(`${currentApi}/${route}`, data)
        } else {
            assertNotEmulatingWrite(route)
            const requestData = {
                ...data,
                updatedBy: globalThis.username,
                currentUserManufacturer: globalThis.userManufacturer,
                // God-mode emulation token (backend honors it only for super
                // admins); null when not emulating.
                emulate: (globalThis as any).osmosisEmulate || undefined,
            }
            apiRoute = await axios.post(`${currentApi}/${route}`, requestData)
        }
    }

    if (type === 'file') {
        assertNotEmulatingWrite(route)
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
            },
        }
        apiRoute = await axios.post(`${currentApi}/${route}`, data, config)
    }
    return apiRoute
}

export default buildRoute
